var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick_with_circle_inactive_ic",
    "data-name": "tick_with_circle inactive_ic",
    transform: "translate(-635 -61)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(635 61)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tick",
    d: "M0,68.105l3.082,3.088L9,65.281l-.85-.838L3.082,69.506.838,67.261Z",
    transform: "translate(641 3.557)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGray);
export default __webpack_public_path__ + "static/media/tickGray.5d59b002f1fb45eb6b860548fb65bf31.svg";
export { ForwardRef as ReactComponent };